export default {
  AppInstance: null,
  setAppInstance(instance) {
    this.AppInstance = instance
  }
}
